export default {
  viewBox: "0 0 16 16",
  html: "<path fill=\"currentColor\" d=\"M14.487 1.513a1.75 1.75 0 0 0-2.474 0l-.772.771 2.475 2.475.771-.772a1.75 1.75 0 0 0 0-2.474M13.009 5.466l-2.475-2.475-8.1 8.1a3.5 3.5 0 0 0-.88 1.476l-.533 1.79a.5.5 0 0 0 .622.622l1.79-.533a3.5 3.5 0 0 0 1.475-.88z\"/>"
};